<template>
   <div class="footer">
    <div class="container">
      <div class="footer-content">
        <div class="footer-left">
         <div class="pic">
          <img class="logo" src="~@/assets/images/LOGO-shokz.webp" alt="">
          <i></i>
          <img class="be-open" src="~@/assets/images/BE_OPEN.webp" alt="">
         </div>
         <div class="desc">
          {{$t('footer.support')}}
         </div>
         <div class="mail">
          <img src="@/assets/icons/mail.svg" alt="">
          <span>support@shokz.com</span>
         </div>
        </div>
        <div class="footer-right pc-show">
         <div class="footer-right-item">
          <div class="title">{{$t('footer.quickLinks')}}</div>
          <ul>
            <li v-for="item in routes" :key="item.path">
              <a v-if="item.path === '/feedback'" href="javascript:void(0);" @click="showFeedback">{{$t(item.meta.title)}}</a>
              <a v-else :href="item.path">{{$t(item.meta.title)}}</a>
            </li>
          </ul>
         </div>
         <div class="footer-right-item">
          <div class="title">{{$t('footer.legalInfo')}}</div>
          <ul>
            <li>
              <a href="/privacy-policy">{{$t('footer.privacyPolicy')}}</a>
            </li>
            <li>
              <a href="/terms-of-use">{{$t('footer.termsOfUse')}}</a>
            </li>
          </ul>
         </div>
        </div>
        <el-collapse class="mb-show">
          <el-collapse-item :title="$t('footer.quickLinks')" name="1">
            <div v-for="item in routes" :key="item.path">
              <a v-if="item.path === '/feedback'" href="javascript:void(0);" @click="showFeedback">{{$t(item.meta.title)}}</a>
              <a v-else :href="item.path">{{$t(item.meta.title)}}</a>
            </div>
          </el-collapse-item>
          <el-collapse-item :title="$t('footer.legalInfo')" name="2">
            <div>
              <a href="/privacy-policy">{{$t('footer.privacyPolicy')}}</a>
            </div>
            <div>
              <a href="/terms-of-use">{{$t('footer.termsOfUse')}}</a>
            </div>
          </el-collapse-item>
        </el-collapse>
        <div class="footer-menu-mb mb-show"></div>
      </div>
      <div class="footer-bottom">
        COPYRIGHT © SHOKZ 粤ICP备11078179号-9 粤公网安备 44030602007030号
      </div>
    </div>
    </div>
</template>

<script>
export default {
  data() {
    return {
      routes:this.$router.options.routes.filter(item => !item.meta.hidden)
    };
  },
  methods: {
    showFeedback() {
      this.$bus.$emit('showFeedback');
    }
  }
}
</script>

<style lang='scss' scoped>
.footer {
  background: #050505;
  padding: 120px 0px;
  .footer-content {
    width: 100%;
    display: flex;
    justify-content: space-between;
    margin-bottom: 60px;
    .footer-left {
     .pic {
      display: flex;
      align-items: center;
      gap: 16px;
      margin-bottom: 24px;
      .logo {
        width: 80px;
      }
      i {
        display: inline-block;
        width: 1px;
        height: 14px;
        background: #E5E5E5;
      }
      .be-open {
        width: 82px;
      }
     }
     .desc {
      font-size: 12px;
      line-height: 16px;
      margin-bottom: 24px;
      color: #A3A3A3;
     }
     .mail {
      display: flex;
      align-items: center;
      img {
        width: 16px;
        margin-right: 12px;
      }
      span {
        font-size: 12px;
        line-height: 16px;
        color: #A3A3A3;
      }
     }
    }
    .footer-right {
      display: flex;
      .footer-right-item {
        margin-left: 120px;
        .title {
          font-size: 16px;
          line-height: 21px;
          color: #FFF;
          margin-bottom: 24px;
        }
        ul{
          display: flex;
          flex-direction: column;
          gap: 12px;
          a {
            color: #A3A3A3;
            font-size: 14px;
            line-height: 19px;
          }
        }
      }
    }
  }
  .footer-bottom {
    width: 100%;
    font-size: 14px;
    line-height: 19px;
    color: #737373;
    padding-top: 16px;
    border-top: 1px solid #404040;
  }
}

@media screen and (max-width: 850px) {
  .footer {
    padding: 64px 0px;
    .footer-content {
      justify-content: flex-start;
      flex-direction: column;
      margin-bottom: 56px;
      .footer-left {
        margin-bottom: 56px;
        .pic {
          margin-bottom: 16px;
          .logo {
            width: 60px;
          }
          i {
            height: 12px;
          }
          .be-open {
            width: 65px;
          }
        }
        .desc {
          font-size: 12px;
          line-height: 16px;
          margin-bottom: 24px;
        }
        .mail {
          img {
            width: 16px;
            margin-right: 12px;
          }
        }
      }
    }
    .footer-bottom {
      width: 100%;
      font-size: 14px;
      line-height: 19px;
      color: #737373;
      padding-top: 16px;
      border-top: 1px solid #404040;
    }
  }
}

::v-deep .el-collapse {
  border: none;
  .el-collapse-item__header {
    background: transparent;
    border: none;
    color: #fff;
  }
  .el-collapse-item__wrap {
    background: transparent;
    border: none;
    a {
      color: #fff;
    }
  }
}
</style>